import React from 'react';

import { LinkConversion } from '../types';

type Props = {
  links: LinkConversion[];
  selectedDay?: string | null;
};

const formatRate = (rate: number | null): string => (rate === null ? '—' : `${rate}%`);

const DubLinksTable: React.FC<Props> = ({ links, selectedDay }) => {
  const visibleLinks = selectedDay ? links.filter((link) => link.dia === selectedDay) : links;

  if (visibleLinks.length === 0) {
    return (
      <p className="px-4 py-6 text-gray-3.0">
        {selectedDay
          ? `No survey links (Dub) for ${selectedDay}.`
          : 'No survey links (Dub) found for the selected accounts.'}
      </p>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full text-sm text-left">
        <thead className="bg-white-1.0 text-gray-3.0">
          <tr>
            <th className="px-4 py-2">Account</th>
            <th className="px-4 py-2">Link</th>
            <th className="px-4 py-2 text-right">Clicks</th>
            <th className="px-4 py-2 text-right">Conversion rate</th>
          </tr>
        </thead>
        <tbody>
          {visibleLinks.map((link) => (
            <tr key={`${link.account_id}-${link.link}`} className="border-t border-gray-2.0">
              <td className="px-4 py-2">{link.account_name}</td>
              <td className="px-4 py-2">
                <a
                  href={link.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-primary-2.0 underline"
                >
                  {link.link}
                </a>
              </td>
              <td className="px-4 py-2 text-right">{link.clicks}</td>
              <td className="px-4 py-2 text-right">{formatRate(link.conversion_rate)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DubLinksTable;
